
  import React from "react"
  import Component from "/Users/shengqing/code/github/cnsmartshow.com/src/layouts/index.js"
  import data from "/Users/shengqing/code/github/cnsmartshow.com/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js